var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('level-bar',[_vm._v(_vm._s(_vm.name))]),_c('intelyt-card',[_c('template',{slot:"header"},[_vm._v("Users")]),_c('base-table',{attrs:{"data":_vm.getUsers(),"columns":_vm.columns,"options":_vm.options}})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }